function Attendance() {
  return <div className="p-4">Attendance Management Screen</div>;
}

export default Attendance;
